import {XHTTP} from '@/shared/xhttp';
import {DateHelper} from "@/shared/utils";

export type ReglementType = 'Chèque'|'Virement'|'Espèces';
export const ReglementType = {
	Cheque   : 'Chèque' as ReglementType,
	Virement: 'Virement' as ReglementType,
	Especes: 'Espèces' as ReglementType,
};


export class SuiviReglement {

	private _id: number;
	private _date: Date = new Date();
	private _montant: number;
	private _reference: string;
	private _type: ReglementType = ReglementType.Cheque;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get montant(): number {
		return this._montant;
	}

	public get reference(): string {
		return this._reference;
	}

	public get type(): ReglementType {
		return this._type ? <any>this._type.toString() : null;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set montant(value: number) {
		this._montant = value;
	}

	public set reference(value: string) {
		this._reference = value;
	}

	public set type(value: ReglementType) {
		this._type = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id            : this._id,
			date 		: this._date ? DateHelper.toLocalizedString(this._date) : null,
			montant       : this._montant,
			reference : this._reference,
			type : this._type ? this._type.toString() : null,
		};
	}

	public fromJSON(data: any): this {
		this._id           = data.id
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._montant        = data.montant;
		this._reference  = data.reference;
		this._type	   = data.type;
		return this;
	}
}
